import React from 'react';
import { useSelector } from 'react-redux';
import { Alert } from '@mui/material';

// Tarja de aviso pro admin quando o plano é de pagamento avulso (sem
// renovação automática) e está perto de vencer - o backend já decide
// `aviso_expiracao` (`users/utils.py::serialize_account_status`), incluído
// tanto no login quanto em `/users/me/` (recarregado a cada F5), então essa
// tarja continua aparecendo mesmo depois de recarregar a página.
const PlanExpirationBanner = () => {
    const user = useSelector((state) => state.account.user);
    const account = user?.account;

    if (!user || user.role !== 'admin' || !account?.aviso_expiracao) {
        return null;
    }

    const dias = account.dias_para_expirar;
    const mensagem =
        dias >= 0
            ? `Seu plano irá expirar em ${dias} dia${dias === 1 ? '' : 's'}. Verifique o pagamento.`
            : `Seu plano venceu há ${Math.abs(dias)} dia${Math.abs(dias) === 1 ? '' : 's'}. Regularize o pagamento para não perder o acesso.`;

    return (
        <Alert severity="warning" sx={{ mb: 2, '& .MuiAlert-message': { fontWeight: 500 } }}>
            {mensagem}
        </Alert>
    );
};

export default PlanExpirationBanner;
